import * as React from 'react'
import ContentLoader from 'react-content-loader'
import { Col, Row } from 'react-styled-flexboxgrid'
import HR from '../../../components/HR'
import Resizable from '../../../interfaces/Resizable'
import {
  ChapterContent,
  ContentOutline,
  Header,
  ProgramContent,
  Selections,
  SelectLanguage,
  SelectLevel,
  SubHeaderOutline,
  TileCol,
  TileLoaderContainer,
  TileRow,
} from './style'

export const MDDimensionLoader: React.FC<Resizable> = ({ height, width = '100%' }) => (
  <ContentLoader
    height={42}
    width={500}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    style={{ height, width }}
  />
)

const Loader: React.FC = () => {
  return (
    <>
      <Header>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12} md={4}>
              <MDDimensionLoader height="42px" />
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6}>
          <Selections end="md">
            <Col xs={5} md={2}>
              <SelectLevel>
                <MDDimensionLoader height="36px" />
              </SelectLevel>
            </Col>
            <Col xs={7} md={3}>
              <SelectLanguage>
                <MDDimensionLoader height="36px" />
              </SelectLanguage>
            </Col>
            <Col xs={12} md={4}>
              <MDDimensionLoader height="36px" />
            </Col>
          </Selections>
        </Col>
      </Header>

      <HR />

      <SubHeaderOutline>
        <Col md={4} className="no-padding">
          <Row>
            <Col md={3}>
              <MDDimensionLoader height="16px" />
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <MDDimensionLoader height="18px" />
            </Col>
          </Row>
        </Col>
        <Col md={8} />
      </SubHeaderOutline>

      <ContentOutline>
        <Col md={4} className="no-padding">
          <Row>
            <Col md={5}>
              <MDDimensionLoader height="20px" />
            </Col>
          </Row>
        </Col>
        <Col md={8} />
      </ContentOutline>

      <ProgramContent>
        <Col md={4} className="no-padding">
          <Row>
            <Col md={6}>
              <MDDimensionLoader height="15px" />
            </Col>
            <Col md={6}>
              <MDDimensionLoader height="15px" />
            </Col>
          </Row>
        </Col>
        <Col md={8} />
      </ProgramContent>

      <ChapterContent>
        <TileRow id="scroller">
          {[1, 2, 3, 4, 5, 6].map(unit => (
            <TileCol id={`tile-${unit}`} onClick={() => {}} key={unit}>
              <TileLoaderContainer>
                <div className="tile-container">
                  <div className="content">
                    <div className="icon" />
                    <div className="text">
                      <MDDimensionLoader height="15px" />
                      <MDDimensionLoader height="15px" />
                    </div>
                  </div>
                  <div className="button">
                    <MDDimensionLoader height="15px" />
                  </div>
                </div>
              </TileLoaderContainer>
            </TileCol>
          ))}
        </TileRow>
      </ChapterContent>
    </>
  )
}

export default Loader
